export function initNotFoundPage() {
    if ($('#NotFoundMsg').length) {
        setTimeout(function () {
            $('#NotFoundMsg').fadeOut();
        }, 5000);
    }
}
